// src/components/Button.jsx
import React from 'react';
// import { GoArrowUpRight } from "react-icons/go";

const ButtonBrochure = ({ text, onClick, type = "button", className = "" }) => {
    return (
        <>
            <button
                activeclassname='text-[#2196f3]'
                onClick={onClick}
                className="flex items-center justify-center whitespace-nowrap text-center text-base font-semibold cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] px-6 py-3"
            >
                <span>{text}</span>
                {/* <GoArrowUpRight className="w-5 h-5 text-white" /> */}
            </button>
        </>

    );
};

export default ButtonBrochure;